export default __webpack_public_path__ + "static/Bitrate_Test_11_WDRMODE_0_1280000-c270abe235940d3192143a5002f1bf91.avif";